import { type ReactElement } from "react";

import clsx from "clsx";

interface MenuItemProps {
  isHovering: boolean;
  isDisabled?: boolean;
  text: string;
  icon?: ReactElement;
  setReference?: any;
}

export const MenuItem = ({
  isHovering,
  isDisabled = false,
  text,
  icon,
  setReference,
  ...rest
}: MenuItemProps) => (
  <div
    className={clsx(
      {
        "hover:cursor-pointer hover:bg-cosmic-5 bg-cosmic-4 font-semibold":
          isHovering && !isDisabled,
        "text-gray pointer-events-none": isDisabled,
      },
      "px-4 py-1.5 flex items-center justify-between",
    )}
    ref={setReference}
    {...rest}
  >
    <div className={clsx({ "text-gray": isDisabled }, "text-cosmic")}>
      {icon}
      <span
        className={clsx(
          { "text-gray": isDisabled, "text-interstellar": !isDisabled },
          "text-sm leading-loose",
        )}
      >
        {text}
      </span>
    </div>
    <i
      className={clsx(
        { "text-gray": isDisabled },
        "fa-regular fa-sharp fa-chevron-right text-cosmic text-xs",
      )}
    />
  </div>
);
